import { useAppSelector } from "app/hooks";
import { selectQuestionTitle } from "features/qualityForm/qualityFormSlice";
import { GuxTruncate } from "genesys-spark-components-react";
import { MarkdownInline } from "features/common/Markdown";
import "./QuestionName.less";
export default function QuestionName({ questionId }: { questionId: string }) {
    const text = useAppSelector((state) =>
        selectQuestionTitle(state, questionId)
    );

    return (
        <div className="QuestionName">
            <GuxTruncate max-lines={15} data-testid="question-name">
                <MarkdownInline
                    markdownInlineText={text ?? ""}
                ></MarkdownInline>
            </GuxTruncate>
        </div>
    );
}
